import React from 'react';
import { Star, Globe, Crown } from 'lucide-react';
import { COLORS } from '../../config/constants';

const ServiCard = ({ servi, onShowDetails }) => {
    const safeServi = servi || {};
    const displayName = safeServi.companyName || safeServi.name || 'Prestador';
    const ratingValue = typeof safeServi.rating === 'number' ? safeServi.rating : 0;

    const statusConfig = {
        'Disponível': { text: 'Disponível', color: COLORS.SUCCESS_GREEN },
        'Agendamento': { text: 'Agendando', color: COLORS.PRIMARY_BLUE },
        'Indisponível': { text: 'Indisponível', color: '#6B7280' },
    };
    const currentStatus = statusConfig[safeServi.status] || statusConfig['Indisponível'];

    let locationDisplay = 'Região não informada';
    if (safeServi.serviceScope === 'nacional') {
        locationDisplay = 'Todo o Brasil';
    } else if (safeServi.regionsAttended && safeServi.regionsAttended.length > 0) {
        const firstRegion = safeServi.regionsAttended[0];
        locationDisplay = typeof firstRegion === 'object' ? firstRegion.name : firstRegion;
        if (safeServi.regionsAttended.length > 1) {
            locationDisplay += ` e +${safeServi.regionsAttended.length - 1}`;
        }
    }

    return (
        <div onClick={onShowDetails} className={`bg-white rounded-xl shadow-md overflow-hidden flex items-stretch mb-3 cursor-pointer transition-transform hover:scale-[1.02] active:scale-[0.98] ${safeServi.isFeatured ? 'ring-2 ring-yellow-400 ring-inset shadow-yellow-100' : ''}`}>
            <div style={{ backgroundColor: currentStatus.color }} className="w-2 flex-shrink-0"></div>
            <div className="flex-grow flex p-3 relative">

                {/* SELO DE PARCEIRO PREMIUM */}
                {safeServi.isFeatured && (
                    <div className="absolute top-2 right-2 flex items-center bg-yellow-400 text-white px-2 py-0.5 rounded-lg shadow-sm z-10">
                        <Crown size={10} className="mr-1 fill-current" />
                        <span className="text-[9px] font-black uppercase tracking-tighter">Premium</span>
                    </div>
                )}

                {/* LOGO FORMATO SQUIRCLE */}
                <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 mr-3 border border-gray-100 bg-white flex items-center justify-center p-1 shadow-sm">
                    <img
                        src={safeServi.photoUrl || `https://ui-avatars.com/api/?name=${displayName.replace(/ /g, '+')}&background=F3F4F6&color=9CA3AF`}
                        alt={displayName}
                        className="w-full h-full object-contain"
                    />
                </div>

                <div className="flex flex-col justify-center min-w-0">
                    <h3 className="font-bold text-gray-800 text-lg leading-tight truncate pr-12">{displayName}</h3>
                    <p className="text-sm font-semibold text-gray-600 truncate">{safeServi.mainCategory || 'Serviços Diversos'}</p>
                    {safeServi.description && <p className="text-xs text-gray-500 mt-1 line-clamp-2">{safeServi.description}</p>}
                    <div className="flex items-center text-xs mt-2 text-gray-500">
                        <Star className="w-3 h-3 mr-1 text-yellow-500 fill-current" />
                        <span className="font-bold mr-2">{ratingValue.toFixed(1)}</span>
                        <Globe className="w-3 h-3 mr-1" />
                        <span className="truncate">{locationDisplay}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiCard;
